
import Vue from '../../plugins/vue';
import BrandStories from './components/BrandStories';
import store from '../shared/store';
document.querySelectorAll('.brandstories-display').forEach(el => {
	new Vue({
		name: 'Brandstories',
		store: store,
		render: h => h(BrandStories, {
			props: {
				entryId: Number.parseInt(el.dataset.entryId),
				index: el.dataset.index ? Number.parseInt(el.dataset.index) : null,
                alwaysVisible: !!el.dataset.alwaysVisible
			}
		})
	}).$mount(el);
});
